module.exports = __webpack_public_path__ + "static/media/tutorial.8f6e9a73.md";